import React, { useState, useEffect, useCallback } from 'react';
import { Box, TextField, List, ListItem, ListItemText, Divider, Typography } from '@mui/material';
import RecipesGallery from '../components/RecipeGallery';
import CircularProgress from '@mui/material/CircularProgress';
// import { apiFetch } from '../utils/api';
import { useSearchParams } from 'react-router-dom';

function SearchPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [query, setQuery] = useState(searchParams.get('query') || '');
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleSearch = useCallback(async () => {
    if (!query) return;

    setLoading(true);
    
    try {
      // Ejemplo de búsqueda de etiquetas (comentado en tu código original)
      //const response = await apiFetch(`/api/search?query=${encodeURIComponent(query)}`);
      //const data = await response.json();
      //setTags(data.tags);
    } catch (error) {
      console.error('Error fetching search results:', error);
    } finally {
      setLoading(false);
    }
  }, [query]);

  useEffect(() => {
    if (query) {
      const timerId = setTimeout(() => {
        handleSearch();
      }, 500); // Añadir un pequeño delay para evitar peticiones por cada tecla

      return () => clearTimeout(timerId);
    } else {
      setTags([]);
    }
  }, [query, handleSearch]);

  useEffect(() => {
    // Sincronizar el estado con los parámetros de la URL
    setSearchParams({ query });
  }, [query, setSearchParams]);

  return (
    <Box sx={{ padding: 3 }}>
      <TextField
        fullWidth
        label="Buscar recetas o etiquetas"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        variant="outlined"
        sx={{ marginBottom: 3 }}
      />

      {loading ? (
        <div style={{ textAlign: 'center', margin: '20px auto' }}>
            <CircularProgress />
        </div>
      ) : (
        <>
          <Typography variant="h6">Recetas</Typography>
          <RecipesGallery searchQuery={query} />

          <Divider sx={{ my: 2 }} />

          <Typography variant="h6">Etiquetas</Typography>
          <List>
            {tags.slice(0, 5).map((tag) => (
              <ListItem key={tag._id} button component="a" href={`/tags/${tag.name}`}>
                <ListItemText primary={tag.name} />
              </ListItem>
            ))}
            {tags.length > 5 && (
              <ListItem component="a" href={`/search?query=${encodeURIComponent(query)}&type=tags`}>
                <ListItemText primary="Más..." />
              </ListItem>
            )}
          </List>
        </>
      )}
    </Box>
  );
}

export default SearchPage;
